import React, { useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Image, message } from 'antd';
import { fetchCurrencyListApi } from 'apis/common/commonApis';

import SubmitButton from 'components/button/SubmitButton';
import ToggleButton from 'components/button/ToggleButton';
import GrayBox from 'components/container/GrayBox';
import Asterisk from 'components/etc/Asterisk';
import UtcTimer from 'components/etc/UtcTimer';
import LargeModal from 'components/form/LargeModal';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import RangeDatePicker from 'components/input/RangeDatePicker';
import DefaultSelect from 'components/select/DefaultSelect';
import PreviewImageSelect from 'components/select/PreviewImageSelect2';
import VerticalTable from 'components/table/VerticalTable';
import LocalizingContext from 'context/LocalizingContext';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { useCookies } from 'react-cookie';
import { currencySetApi } from 'apis/platform/currencyApis';
import { coinStoreApi } from 'apis/sales/coinStoreApis';
import { useTranslation } from 'react-i18next';
/**
 * * 판매 - 코인상점 관리 등록 & 수정 모달
 */

const CoinStoreInputModal = ({
  visible,
  setVisible,
  fetchData,
  record,
  setSelectData,
}) => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const langList = useContext(LocalizingContext);
  const dateFormat = 'YYYY-MM-DD HH:mm:00';
  const today = dayjs().format(dateFormat);
  const [localizingData, setLocalizingData] = useState();
  const [coinDetailData, setCoinDetailData] = useState({
    currency: [],
    is_public: 0,
    start_date: today,
    // end_date: today,
    end_date: '9999-12-31 00:00:00',
    price: 0,
    sale_price: 0,
    sale_kind: 1,
    thumbnail_id: -1,
    detail_page_id: -1,
    is_common: 0,
  }); //상세정보
  const [setProductData, setSetProductData] = useState(); // 세트 상품 [{coin_product_id:0, currency:''}]
  const [currencyDropList, setCurrencyDropList] = useState();
  const [thumbDropList, setThumbDropList] = useState();

  //** 모달 닫기 */
  const handleClose = () => {
    setVisible(false);
    setSelectData();
  };

  //** 다국어 상품명 변경 */
  const handleChangeName = (e) => {
    setLocalizingData(
      localizingData.map((v) =>
        v.lang === e.target.id ? { ...v, name: e.target.value } : v,
      ),
    );
  };

  //** 인풋 & 체크박스 */
  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === 'is_common' || name === 'is_public') {
      setCoinDetailData({
        ...coinDetailData,
        [name]: checked === true ? 1 : 0,
      });
    } else {
      setCoinDetailData({ ...coinDetailData, [name]: value });
    }
  };

  //** 상품 종류 검색으로 조회 */
  const keyDownSearch = async (e) => {
    const resCurrencyList = await fetchCurrencyListApi(e.target.value);
    setCurrencyDropList(resCurrencyList);
  };

  /// 상품 종류 드롭다운 선택
  const handleSelectProduct = async (value) => {
    // setList [{currency: ''}] 형식으로 담기. 세트 상품인데 우선 보류라고 한다. (22.6.30.지연)
    let newData = [];
    value.map((v) => newData.push({ currency: v }));
    setSetProductData(newData);

    // console.log(value.toString());
    let resThumb = await coinStoreApi.coinCurrencyThumb(value.toString());
    if (!resThumb) {
      return false;
    }

    // 상품종류(currency) 선택했을때 언어별 상품명에 name 적용
    if (value.length === 1) {
      let currencyLang = resThumb[0];

      // 다국어명이 key 값으로 들어가 있다.
      // key 명을 로컬라이징 데이터의 lang 값으로 들어가야 한다.
      for (const [key, value] of Object.entries(currencyLang)) {
        localizingData?.map((v) => v.lang === key && (v.name = value));
      }
      setLocalizingData([...localizingData], [localizingData]);
    }

    // 상품이 1개일 경우, 해당 썸네일 데이터 호출
    if (resThumb.length > 0) {
      setCoinDetailData({
        ...coinDetailData,
        currency: value,
        thumbnail_url: resThumb[0].thumbnail_id_url,
        thumbnail_id: resThumb[0].thumbnail_id,
        thumbnail_key: resThumb[0].thumbnail_id_key,
      });
    } else {
      setCoinDetailData({ ...coinDetailData, currency: value });
    }
  };

  //** 날짜 선택 */
  const handleDateChange = (dates, dateStrings) => {
    if (!dates) {
      setCoinDetailData({
        ...coinDetailData,
        start_date: `${today}`,
        end_date: `${today}`,
      });
      return;
    }
    setCoinDetailData({
      ...coinDetailData,
      start_date: `${dateStrings[0]}`,
      end_date: `${dateStrings[1]}`,
    });
  };

  //** 무제한 체크 */
  const handleCheckUnlimited = (e) => {
    e.target.checked === true
      ? setCoinDetailData({
          ...coinDetailData,
          end_date: '9999-12-31 00:00:00',
        })
      : setCoinDetailData({ ...coinDetailData, end_date: `${today}` });
  };

  //** 썸네일 이미지 드롭다운 */
  const handleChangeThumbnail = (val) => {
    setCoinDetailData({ ...coinDetailData, thumbnail_id: val });
  };
  //** 서버 등록하기 */
  const handleSubmit = async () => {
    console.log(
      record ? record.coin_product_id : 0,
      coinDetailData,
      localizingData,
      setProductData,
    );
    if (coinDetailData.currency.length === 0) {
      alert(t('coinStore.coinStoreModal.alertSubmit'));
      return false;
    }

    const res = await coinStoreApi.coinStoreRegister(
      record ? record.coin_product_id : 0,
      coinDetailData,
      localizingData,
      setProductData,
    );
    if (!res) {
      return false;
    }

    message.success(
      `${t('coinStore.coinStoreModal.coinShopProduct')} ${
        record
          ? t('coinStore.coinStoreModal.edit')
          : t('coinStore.coinStoreModal.register')
      } ${t('coinStore.coinStoreModal.done')}`,
    );
    handleClose();
    fetchData();
  };

  //** 상세 정보 불러오기 */
  const fetchInputData = async (productId) => {
    const res = await coinStoreApi.detail(productId);

    // 다국어 데이터 재가공
    let newLocalArr = [];
    langList?.map((v, i) =>
      newLocalArr.push({
        key: i,
        lang: v.code,
        lang_name: v.code_name,
        name: '',
      }),
    );

    for (let i = 0; i < newLocalArr.length; i++) {
      for (let j = 0; j < res?.lang?.length; j++) {
        if (newLocalArr[i].lang.indexOf(res?.lang[j].lang) !== -1) {
          // Object.assign(target, ...sources)
          // 파라미터로 받은 소스 객체 속성을 target 객체로 복사한다.
          Object.assign(newLocalArr[i], res.lang[j]);
        }
      }
    }
    setLocalizingData(newLocalArr);

    // 코인상점 디테일
    // 상품 종류. 다중 셀렉 박스로 사용하기 위해 배열로 재가공
    let currencyArr = res?.detail[0]?.currency?.split(',');

    //재화url이 없을때, 한 번 더 재화관리에 들어가서 해당id url갱신해준다.

    console.log(res?.detail[0].currency, '<currency');
    const urlRes = await currencySetApi.detail(res?.detail[0].currency);
    console.log(urlRes);

    setCoinDetailData({
      ...res?.detail[0],
      currency: currencyArr,
      thumbnail_id: urlRes.detail[0].icon_image_id,
      thumbnail_url: urlRes.detail[0].icon_image_url,
    });
  };

  //** 드롭다운 데이터 불러오기 */
  const fetchDropdown = async () => {
    const resCurrencyList = await fetchCurrencyListApi('');
    const resThumbnail = await coinStoreApi.thumbnailImgList();

    setCurrencyDropList(resCurrencyList);
    setThumbDropList(resThumbnail);
  };

  useEffect(() => {
    if (record) {
      fetchInputData(record?.coin_product_id).catch(console.log);
      setCoinDetailData(record);
    } else {
      // 다국어 초기화
      let newArr = [];
      langList?.map((v, i) =>
        newArr.push({
          coin_product_id: 0,
          lang: v.code,
          lang_name: v.code_name,
          name: '',
          key: i,
        }),
      );
      setLocalizingData(newArr);
    }
    fetchDropdown().catch(console.log);
  }, []);

  const footerComponent = [
    <SubmitButton onClick={handleSubmit} disabled={authUpdate}>
      {record
        ? t('coinStore.coinStoreModal.editButton')
        : t('coinStore.coinStoreModal.registerButton')}
    </SubmitButton>,
  ];
  return (
    <LargeModal
      visible={visible}
      title={`${t('coinStore.coinStoreModal.coinShop')} ${
        record
          ? t('coinStore.coinStoreModal.edit')
          : t('coinStore.coinStoreModal.register')
      }`}
      onCancel={handleClose}
      footer={footerComponent}
    >
      <div className='input_wrap'>
        <GrayBox left style={{ height: '40rem' }}>
          <LangTableStyled>
            <tr>
              <td
                style={{
                  color: `${theme.colors.blueText}`,
                  fontSize: '0.95rem',
                }}
              >
                {t('coinStore.coinStoreModal.productName')}
              </td>
              <td></td>
            </tr>
            {localizingData?.map((v, i) => (
              <tr key={i}>
                <td>{t(`dbLngList.${i}.code_name`)}</td>
                <td>
                  <DefaultInput
                    id={v.lang}
                    value={v.name}
                    onChange={handleChangeName}
                    placeholder={`${t(`dbLngList.${i}.code_name`)} ${t(
                      'coinStore.coinStoreModal.productNameInputPlaceholder',
                    )}`}
                    maxLength={60}
                    allowClear
                  />
                </td>
              </tr>
            ))}
          </LangTableStyled>
        </GrayBox>
        <GrayBox style={{ height: '40rem' }}>
          <VerticalTable>
            <>
              <tr>
                <th>
                  {t('coinStore.coinStoreModal.productType')}
                  <Asterisk />
                </th>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <DefaultSelect
                      name='currency'
                      optionList={currencyDropList}
                      value={coinDetailData?.currency}
                      style={{ width: '60%' }}
                      onChange={handleSelectProduct}
                      onKeyUp={keyDownSearch}
                      filterOption={false}
                      mode='multiple'
                      allowClear
                      showSearch
                      placeholder={t(
                        'coinStore.coinStoreModal.productTypeInputPlaceholder',
                      )}
                    />
                    <CheckboxOneType
                      style={{ margin: '0 10px' }}
                      // defaultChecked={false}
                      disabled={true}
                      checked={
                        coinDetailData?.currency?.length > 1 ? true : false
                      }
                    >
                      {t('coinStore.coinStoreModal.setProduct')}
                    </CheckboxOneType>
                    <CheckboxOneType
                      name='is_common'
                      checked={coinDetailData?.is_common === 1 && true}
                      onChange={handleInputChange}
                    >
                      {t('coinStore.coinStoreModal.isPublic')}
                    </CheckboxOneType>
                  </div>
                  <p className='description' style={{ marginTop: '0.3rem' }}>
                    {t('coinStore.coinStoreModal.productTypeDescription')}
                  </p>
                </td>
              </tr>
              <tr>
                <th>{t('coinStore.coinStoreModal.salePeriod')}</th>
                <td>
                  <div style={{ display: 'flex' }}>
                    <RangeDatePicker
                      // style={{ width: '60%' }}
                      format={dateFormat}
                      ranges={{
                        오늘: [dayjs(), dayjs()],
                        이번주: [dayjs().startOf(today), dayjs().endOf('week')],
                        이번달: [
                          dayjs().startOf(today),
                          dayjs().endOf('month'),
                        ],
                      }}
                      value={[
                        dayjs(coinDetailData?.start_date, dateFormat),
                        dayjs(coinDetailData?.end_date, dateFormat),
                      ]}
                      showTime={true}
                      onChange={handleDateChange}
                    />
                    <CheckboxOneType
                      style={{ margin: '0 10px' }}
                      onChange={handleCheckUnlimited}
                      checked={
                        coinDetailData?.end_date === '9999-12-31 00:00:00'
                          ? true
                          : false
                      }
                    >
                      {t('coinStore.coinStoreModal.salePeriodUnlimited')}
                    </CheckboxOneType>
                  </div>
                  <UtcTimer
                    onGrayBox={true}
                    startDate={coinDetailData?.start_date}
                    endDate={coinDetailData?.end_date}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('coinStore.coinStoreModal.productPrice')}</th>
                <td>
                  <DefaultInput
                    type='number'
                    name='price'
                    value={coinDetailData?.price}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('coinStore.coinStoreModal.salePrice')}</th>
                <td>
                  <DefaultInput
                    type='number'
                    name='sale_price'
                    value={coinDetailData?.sale_price}
                    onChange={handleInputChange}
                  />
                  <DefaultRadio
                    style={{ marginLeft: '10px' }}
                    // onChange={handleChangeSalePercent}
                    defaultValue={coinDetailData?.sale_kind}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('coinStore.coinStoreModal.disclose')}</th>
                <td>
                  <ToggleButton
                    name='is_public'
                    checked={coinDetailData?.is_public === 1 ? true : false}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              {coinDetailData?.currency?.length >= 1 && (
                <tr>
                  <th>{t('coinStore.coinStoreModal.productThumbnail')}</th>
                  <td>
                    {coinDetailData?.currency?.length > 1 ? (
                      <PreviewImageSelect
                        recWidth='100px'
                        selWidth='100px'
                        width50={true}
                        optionList={thumbDropList}
                        imgUrl={coinDetailData?.thumbnail_url}
                        onChange={handleChangeThumbnail}
                      />
                    ) : (
                      <Image
                        src={coinDetailData?.thumbnail_url}
                        alt={coinDetailData?.currency_name}
                        style={{ maxWidth: '20rem' }}
                      />
                    )}
                  </td>
                </tr>
              )}
            </>
          </VerticalTable>
        </GrayBox>
      </div>
    </LargeModal>
  );
};

export default CoinStoreInputModal;

const LangTableStyled = styled(VerticalTable)`
  tr {
    width: 100%;
    display: flex;
    align-items: center;
    /* justify-content: flex-start; */
    td:nth-child(1) {
      text-align: right;
      width: 5rem;
      font-weight: 700;
      font-size: 0.9rem;
    }
    td:nth-child(2) {
      /* background-color: pink; */
      padding-left: 1rem;
      width: 100%;
    }
  }
`;
